import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';
import { Platform } from './platform.resource';

@Resource({
  type: 'errorcodes',
})
export class Errorcode extends AtomResource {
  @Attribute() code?: string;
  @Attribute() name?: string;
  @Attribute() desc?: string;

  @Relationship() platform?: Platform;
}

export class ErrorcodeConfig implements ResourceConfig {
  hosted = 'platform';
  tables = {
    options: {
      copy: true,
    },
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'code',
        displayedDatas: [{ path: ['code'] }],
        header: 'Code',
        displayed: true,
      },
      {
        columnDef: 'name',
        displayedDatas: [{ path: ['name'] }],
        header: 'Name',
        displayed: true,
      },
      {
        columnDef: 'desc',
        displayedDatas: [{ path: ['desc'] }],
        header: 'Description',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'error',
      title: [
        {
          path: ['code', 'name'],
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            icon: 'code',
            title: 'Code',
            APIKey: 'code',
            value: {
              path: ['code'],
            },
          },
          {
            icon: 'badge',
            title: 'Name',
            APIKey: 'name',
            value: {
              path: ['name'],
            },
          },
          {
            icon: 'edit',
            title: 'Descritpion',
            APIKey: 'desc',
            value: {
              path: ['desc'],
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Error Code',
        formGroup: 'errorcode',
        list: [
          {
            type: 'text',
            title: 'Code',
            APIKey: 'code',
            formControl: 'code',
            required: true,
          },
          {
            type: 'text',
            title: 'Name',
            APIKey: 'name',
            formControl: 'name',
            required: true,
          },
          {
            type: 'text',
            title: 'Description',
            APIKey: 'desc',
            formControl: 'desc',
            translatable: true,
            required: true,
            noCols: true,
          },
        ],
      },
    ],
  };
  resource = Errorcode;
  resourceName = 'Error Codes';
  resourceKey = 'errorcodes';
  resourceKeySingle = 'errorcode';
  includes = [];
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('code', 'code', true),
    new StringFilter('name', 'Name'),
  ];
}
